<template >
  
  <div >
    <top-header />
    <div class="banner">
      <div class="container" >
        <div class="search-type"  >
          <label @click="handelSelectSearchType(1)" :class="search_type == 1 ? 'active' : null " >找人</label>
          <label @click="handelSelectSearchType(2)" :class="search_type == 2 ? 'active' : null ">找工作</label>
        </div>
        <div class="search-wrap" > 
          <input class="search-input" :placeholder="search_type  == 1 ? '输入找人的姓名' : '输入要找的工作岗位'" />
          <button class="search-btn" >搜索</button>
        </div>
      </div>
    </div>
    <div class="container" >
        <ul  class="search-list clearfix">
          <li @click="handelClickPerson(item)" v-for="(item, index) in search_user_result" :key="index">
            <div class="search-item" >
              <div class="search-item-title" >
                {{item.user_name}}
              </div>
               <div class="search-item-intro" >
               {{item.company}} - {{item.job_name}}
              </div>
            </div>
          </li>
        </ul>

        <ul  class="search-list clearfix">
          <li  @click="handelClickJob(item)" v-for="(item, index) in search_job_result" :key="index">
            <div class="search-item" >
              <div class="search-item-title" >
                {{item.job_name}}
                
              </div>
               <div class="search-item-intro" >
               
               {{item.company}} - {{item.salary}}
              </div>
            </div>
          </li>
        </ul>

         <ul  class="search-list clearfix">
          <li  @click="handelClickCompany(item)" v-for="(item, index) in search_job_result" :key="index">
            <div class="search-item" >
              <div class="search-item-title" >
                {{item.company}} - {{item.salary}}
              </div>
               <div class="search-item-intro" >
               
               {{item.job_name}}
              </div>
            </div>
          </li>
        </ul>

    </div>
    <foter />
  </div>
</template>

<style scoped lang="postcss">
.search-type {
  font-size: 14px;
  text-align: left;
  // margin: 10px;
  color: #fff;
  width: 510px;
  margin: 10px auto;

  & label {
    cursor: pointer;
  }
  & .active {
    color: dodgerblue;
  }
}
.search-input {
  color: #333;
  width: 400px;
  height: 30px;
  padding: 4px 10px;
  border-radius: 4px;
  border: none;
  outline: none;
}
.search-btn {
  background: dodgerblue;
  color: #fff;
  border: none;
  border-radius: 20px;
  width: 90px;
  height: 30px;
  margin-left: 10px;
}
.search-list {
  margin: 50px 20px;
}
.search-list li {
  float: left;
}
.search-item {
  border: 1px solid #eee;
  box-shadow: 0 0 4px #eee;
  padding: 20px;
  margin: 10px;
  width: 400px;
  &-title {
    font-size: 20px;
  }

  &-intro {
    color: #999;
  }

  &:hover {
    box-shadow: 1px 1px 4px #999;
    cursor: pointer;
  }
}
.banner {
  background: #051d3b;
  color: #fff;
  padding: 20px;
  text-align: center;
  & p {
    padding: 10px;
    font-weight: 300;
    line-height: 1.56;
    letter-spacing: normal;
  }

  background: linear-gradient(90deg, #051d3b, #06264d); /* 标准的语法 */
}
</style>


<script>
import TopHeader from '@components/TopHeader'
import Footer from '@components/Footer'

export default {
  methods: {
    handelClickPerson: function (item) {
      window.location.href = "/detail.html#/person"
    },
    handelClickCompany: function (item) {
      window.location.href = "/detail.html#/company"
    },
    handelClickJob: function (item) {
      window.location.href = "/detail.html#/job"
    },
    handelSelectSearchType: function (type) {
      this.search_type = type;
    }
  },
  components: {
    'top-header': TopHeader,
    'foter': Footer,
  },
  name: 'app',
  data() {
    return {
      search_type: 1,
      search_user_result: [
        {
          user_name: '陈金亚',
          company: '欢聚时刻科技有限公司',
          job_name: '联合创始人'
        },
        {
          user_name: '马继德',
          company: '欢聚时刻科技有限公司',
          job_name: '联合创始人'
        },
        {
          user_name: '梁明一',
          company: '百度在线',
          job_name: 'PHP研发工程师'
        }],
      search_job_result: [
        {
          company: '欢聚时刻科技有限公司',
          job_name: 'PHP研发工程师',
          salary: '20k',
        },
        {
          company: '欢聚时刻科技有限公司',
          job_name: '安卓研发工程师',
          salary: '20k',
        },
        {
          salary: '20k',
          company: '百度在线',
          job_name: 'PHP研发工程师'
        }],


    };
  },
  created: function () {
  }
};
</script>




// WEBPACK FOOTER //
// ViewSearch.vue?7fc92e08